'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _constants = require('../../constants');
var _validate = require('../../utils/validate');

var _ContactUsForm = require('./ContactUsForm.scss');var styles = _interopRequireWildcard(_ContactUsForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Components

var UserDetailsSection = function UserDetailsSection(properties) {var _cx;return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(
        properties.usage === _constants.contactUsUsage.agent || properties.usage === _constants.contactUsUsage.realtorPackages ?
        styles.agentForm :
        styles.userDetailsSection, (_cx = {}, _cx[
        styles.realtorProperties] = properties.usage === _constants.contactUsUsage.realtorPackages, _cx)) },


      _react2.default.createElement(_reactScroll.Element, { name: 'name', className: styles.contentRow },
        _react2.default.createElement(_components.OMInputWithLable, {
          title: '' + properties.translate('nameTitle'),
          name: 'name',
          placeholder: '' + properties.translate('namePlaceholder'),
          field: {
            onChange: properties.handleChange,
            isInvalid: properties.fieldIsInvalid('name'),
            validate: function validate(value) {return !!value;} },

          className: properties.usage === _constants.contactUsUsage.projects ? 'projectsContactUsForm' : 'contactUsForm',
          required: true,
          isRtl: properties.isRtl })),


      _react2.default.createElement(_reactScroll.Element, { name: 'email', className: styles.contentRow },
        _react2.default.createElement(_components.OMInputWithLable, {
          title: '' + properties.translate('emailTitle'),
          name: 'email',
          placeholder: '' + properties.translate('emailPlaceholder'),
          field: {
            onChange: properties.handleChange,
            isInvalid: properties.fieldIsInvalid('email'),
            showHoverTooltip: true,
            tooltipMessage: '' + properties.translate('emailTooltipMessage'),
            isMobile: properties.isMobile,
            validate: _validate.emailRegexValidation },

          className: properties.usage === _constants.contactUsUsage.projects ? 'projectsContactUsForm' : 'contactUsForm',
          required: true,
          isRtl: properties.isRtl })),


      _react2.default.createElement('div', { className: styles.contentRow },
        _react2.default.createElement(_components.OMInputWithLable, {
          title: '' + properties.translate('phoneTitle'),
          name: 'phone',
          placeholder: '' + properties.translate('phonePlaceholder'),
          field: {
            onChange: function onChange(evt) {
              var value = evt.target.value;
              evt.target.value = value.replace(/[\D]/g, '').slice(0, 10);
              properties.handleChange(evt);
            },
            isInvalid: properties.fieldIsInvalid('phone') },

          className: properties.usage === _constants.contactUsUsage.projects ? 'projectsContactUsForm' : 'contactUsForm',
          required: properties.isPageForRealtor,
          isRtl: properties.isRtl })),


      (properties.usage === _constants.contactUsUsage.agent || properties.usage === _constants.contactUsUsage.realtorPackages) &&
      _react2.default.createElement('div', { className: styles.contentRow },
        _react2.default.createElement(_components.OMInputWithLable, {
          title: '' + properties.translate('companyName'),
          name: 'companyName',
          placeholder: '' + properties.translate('companyName'),
          field: {
            onChange: properties.handleChange,
            isInvalid: properties.fieldIsInvalid('companyName'),
            validate: function validate(value) {return !!value;} },

          className: properties.usage === _constants.contactUsUsage.projects ? 'projectsContactUsForm' : 'contactUsForm',
          required: true,
          isRtl: properties.isRtl }))));}; // Styles
// Helpers
// Modules
exports.default =



UserDetailsSection;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUsForm/UserDetailsSection.js
// module id = 2606
// module chunks = 0